"use client";

import { trackClickEvent } from "@/lib/tracking";
import { usePathname } from "next/navigation";

type Product = {
  slug: string;
  name: string;
  category: string;
  shortDesc: string;
  tags: string[];
};

const PRODUCTS: Product[] = [
  {
    slug: "feature-testing-agent",
    name: "Feature Testing Agent",
    category: "Quality Engineering",
    shortDesc:
      "Generate test ideas, scenarios, and smoke suites for each feature automatically.",
    tags: ["QA", "Regression", "Observability"]
  },
  {
    slug: "multivariate-experiment-agent",
    name: "Multi-Variant Experiment Agent",
    category: "Growth",
    shortDesc:
      "Design and orchestrate A/B/n and multivariate tests with AI-guided recommendations.",
    tags: ["Growth", "A/B Testing", "Experimentation"]
  },
  {
    slug: "agri-insights-agent",
    name: "Agri-Insights Agent",
    category: "Agriculture",
    shortDesc:
      "Smallholder-friendly agent for irrigation, crop advisory, and yield forecasting.",
    tags: ["Farming", "Weather", "Advisory"]
  },
  {
    slug: "credit-card-advisor-agent",
    name: "Credit Card Advisor Agent",
    category: "Fintech",
    shortDesc:
      "Agentic engine to recommend the right card stack across rewards, fees, and lifestyle.",
    tags: ["Fintech", "Cards", "Recommendation"]
  }
];

export default function ProductCards() {
  const path = usePathname();

  function handleLearnMoreClick(name: string) {
    trackClickEvent("product_card_click", path || "/products", name);
  }

  return (
    <div className="grid gap-6 md:grid-cols-2">
      {PRODUCTS.map(p => (
        <article
          key={p.slug}
          className="gradient-border flex flex-col justify-between bg-slate-950/60 p-5"
        >
          <div>
            <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-blue-300">
              {p.category}
            </div>
            <h3 className="text-lg font-semibold">{p.name}</h3>
            <p className="mt-2 text-sm text-slate-300">{p.shortDesc}</p>
          </div>
          <div className="mt-4 flex flex-wrap items-center justify-between gap-2">
            <div className="flex flex-wrap gap-2">
              {p.tags.map(tag => (
                <span
                  key={tag}
                  className="rounded-full bg-slate-800 px-3 py-1 text-[11px] text-slate-200"
                >
                  {tag}
                </span>
              ))}
            </div>
            <button
              type="button"
              onClick={() => handleLearnMoreClick(p.name)}
              className="text-[11px] font-semibold text-blue-300 underline underline-offset-2"
            >
              Track interest
            </button>
          </div>
        </article>
      ))}
    </div>
  );
}
